import { render, staticRenderFns } from "./IeNotification.vue?vue&type=template&id=445d1ef0"
import script from "./IeNotification.vue?vue&type=script&lang=js"
export * from "./IeNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports